module.exports = __webpack_public_path__ + "img/story.eee30904.png";